<script setup lang="ts">
  import { computedAsync } from '@vueuse/core'
  import { useBestLocale } from '@/plugins/i18n'
  import { Analytics } from '@vercel/analytics/vue'
  import { SpeedInsights } from '@vercel/speed-insights/vue'
  import NavbarComponent from '@/components/NavbarComponent.vue'
  import { Toaster } from 'vue-sonner'
  import { usePwaUpdate } from '@/composables/usePwaUpdate'
  import { useRouter } from 'vue-router'
  import { useDarkMode } from '@/composables/useDarkMode'

  useBestLocale()
  usePwaUpdate()
  useDarkMode()

  const router = useRouter()
  const routerReady = computedAsync(async () => {
    await router.isReady()
    return true
  }, false)
</script>

<template>
  <Toaster
    position="bottom-right"
    :rich-colors="true"
  />
  <Analytics />
  <SpeedInsights />
  <template v-if="routerReady">
    <NavbarComponent />
    <RouterView v-slot="{ Component }">
      <KeepAlive :include="['DeckView', 'MapView']">
        <component :is="Component" />
      </KeepAlive>
    </RouterView>
  </template>
</template>
